import script from "./ProtocoloQueda.vue?vue&type=script&setup=true&lang=js"
export * from "./ProtocoloQueda.vue?vue&type=script&setup=true&lang=js"

import "./ProtocoloQueda.vue?vue&type=style&index=0&id=423373e0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-423373e0"]])

export default __exports__